import React, { Fragment, useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData, updateData, postData } from '../../../apiService';
import { faL } from '@fortawesome/free-solid-svg-icons';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import CircularProgress from '@mui/material/CircularProgress';
import CloseIcon from '@mui/icons-material/Close';
import CopyrightIcon from '@mui/icons-material/Copyright';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import PrintIcon from '@mui/icons-material/Print';
import gender from './gender_looms_logo.png';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

const NewSaleDetails = () => {
    const { id } = useParams(); // Use useParams to get the id from the URL
    const history = useHistory();
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [errorMessageModel, setErrorMessageModel] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const { isAuthenticated, companyId, branchId, userId, permissions, token, logout, branchstate, roleName } = useAuth();
    const [selectedGWPorPWP, setSelectedGWPorPWP] = useState(false); // Default to YES

    const [selectedSalesMan, setSelectedSalesMan] = useState("");
    const [dropdownSalesManOptions, setDropdownSalesManOptions] = useState([]);

    const [selectedDiscType, setSelectedDiscType] = useState("");
    const [dropdownDiscTypeOptions, setDropdownDiscTypeOptions] = useState([]);

    const [selectedCardType, setSelectedCardType] = useState("");
    const [dropdownCardTypeOptions, setDropdownCardTypeOptions] = useState([]);

    const [showCardFields, setShowCardFields] = useState(false);
    const [showupiFields, setShowupiFields] = useState(false);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, companyId, branchId, token, logout]);

    useEffect(() => {
        fetchDropdownSalesManOptions();
        fetchDropdownCardTypeOptions();
        fetchDropdownDiscTypeOptions();
    }, []);

    const fetchDropdownSalesManOptions = () => {
        fetchData('SaleApi', `/SalesMan/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownSalesManOptions(data);
            })
            .catch((error) => {
                console.error('Error fetching Sales Man dropdown options:', error);
            });
    };

    const fetchDropdownDiscTypeOptions = () => {
        fetchData('SaleApi', `/DiscType/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownDiscTypeOptions(data);
            })
            .catch((error) => {
                console.error('Error fetching Disc Type dropdown options:', error);
            });
    };

    const fetchDropdownCardTypeOptions = () => {
        fetchData('SaleApi', `/CardType/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownCardTypeOptions(data);
            })
            .catch((error) => {
                console.error('Error fetching Card Type dropdown options:', error);
            });
    };

    const hasCreateTransactionPermission = permissions.includes('Create Transaction');
    const hasEditTransactionPermission = permissions.includes('Edit Transaction');
    const hasDeleteTransactionPermission = permissions.includes('Delete Transaction');

    const [formData, setFormData] = useState([]);
    const [invoicedeatils, setInvoicedeatils] = useState([]);

    useEffect(() => {
        fetchData('SaleApi', `/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setFormData(response.response_data.Sale);
                    setInvoicedeatils(response.response_data.SaleDetails);
                    setFormData(prevData => ({
                        ...prevData,
                        UpdatedBy: userId,
                    }));

                    setSelectedSalesMan(response.response_data.Sale.SalesManId);
                    setSelectedCardType(response.response_data.Sale.CardType);
                    setSelectedDiscType(response.response_data.Sale.DiscTypeId);
                    setSelectedGWPorPWP(response.response_data.Sale.GWPorPWPIncluded);
                }
            })
            .catch((error) => {
                console.error('Error fetching Sale Details:', error);
            });
    }, [id]);

    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;

        return formattedDate;
    };

    // const generateInvoice = async (saleId) => {
    //     try {
    //         const response = await fetchData('SaleApi', `/SalePrint/${saleId}/${branchId}`, token);
    //         const labelData = response.response_data;

    //         if (!labelData?.SalePrint || !labelData?.SalePrintDetails) {
    //             throw new Error("Invalid invoice data.");
    //         }

    //         const header = labelData.SalePrint;
    //         const items = labelData.SalePrintDetails;

    //         const doc = new jsPDF({
    //             orientation: 'portrait',
    //             unit: 'mm',
    //             format: [80, 297]
    //         });

    //         let y = 6;

    //         doc.addImage(gender, 'PNG', 15, 2, 50, 20);
    //         y += 13;

    //         // Invoice Meta
    //         doc.setFontSize(6.5);
    //         const pageWidth = doc.internal.pageSize.getWidth();

    //         doc.setFont('helvetica', 'bold');
    //         doc.text('INVOICE', pageWidth / 2, y + 5, { align: 'center' });

    //         doc.setFont('helvetica', 'bold');
    //         const invNo = [header.BillPrefix, header.FinYear, header.BillNumber].filter(Boolean).join('/');
    //         doc.text(`Inv.No: ${invNo}`, 5, y + 8);
    //         doc.text(`Customer: ${header.CustomerName || ''}`, 5, y + 12);

    //         const billDate = header.BillDate || '';
    //         const createdDate = header.CreatedDate || '';
    //         //const formattedDate = billDate ? new Date(billDate).toLocaleDateString() : '';
    //         const formattedDate = billDate
    //             ? new Date(billDate).toLocaleDateString('en-GB', {
    //                 day: '2-digit',
    //                 month: 'short',
    //                 year: 'numeric'
    //             }).replace(/ /g, '-')
    //             : '';

    //         const formattedTime = createdDate ? new Date(createdDate).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : '';

    //         doc.text(`Date: ${formattedDate}`, pageWidth - 5, y + 8, { align: 'right' });
    //         doc.text(`Time: ${formattedTime}`, pageWidth - 5, y + 12, { align: 'right' });

    //         y += 18;

    //         // Filter items
    //         const filteredItems = items.filter(item => (item.Quantity ?? 0) > 0 || (item.Total ?? 0) > 0);

    //         const itemRows = filteredItems.map(item => [
    //             { content: item.ItemName || '', styles: { cellWidth: 40, valign: 'top' } },
    //             { content: (item.Quantity ?? 0).toString(), styles: { halign: 'center' } },
    //             { content: (item.Rate ?? 0).toFixed(2), styles: { halign: 'right' } },
    //             { content: (item.TotalAmount ?? 0).toFixed(2), styles: { halign: 'right' } }
    //         ]);

    //         const totalQuantity = filteredItems.reduce((sum, item) => sum + (item.Quantity ?? 0), 0);

    //         itemRows.push([
    //             { content: 'Total', styles: { halign: 'right', fontStyle: 'bold' } },
    //             { content: totalQuantity.toString(), styles: { halign: 'center', fontStyle: 'bold' } },
    //             { content: '', styles: {} },
    //             { content: (header.GrandTotal ?? 0).toFixed(2), styles: { halign: 'right', fontStyle: 'bold' } }
    //         ]);

    //         autoTable(doc, {
    //             startY: y,
    //             margin: { left: 5 },
    //             head: [['NAME OF PRODUCT', 'QTY', 'RATE', 'TOTAL']],
    //             body: itemRows,
    //             styles: {
    //                 fontSize: 6.5,
    //                 textColor: [0, 0, 0],
    //                 cellPadding: { top: 0.5, bottom: 0.5, left: 1, right: 1 },
    //                 overflow: 'linebreak',
    //                 lineColor: [0, 0, 0], // ⬅️ border color black
    //             },
    //             theme: 'grid',
    //             headStyles: {
    //                 fillColor: [255, 255, 255],
    //                 textColor: [0, 0, 0],
    //                 fontStyle: 'bold',
    //                 lineColor: [0, 0, 0] // ⬅️ border color black for header
    //             },
    //             columnStyles: {
    //                 0: { cellWidth: 30 },
    //                 1: { cellWidth: 8 },
    //                 2: { cellWidth: 10 },
    //                 3: { cellWidth: 12 },
    //             },
    //         });


    //         let finalY = (doc.lastAutoTable?.finalY ?? y) + 3;

    //         // Tax summary
    //         const taxSummaryLines = [
    //             ['Taxable Amt', (header.TaxableAmount ?? 0).toFixed(2)],
    //             ['CGST Amt', (header.CGSTAmount ?? 0).toFixed(2)],
    //             ['SGST Amt', (header.SGSTAmount ?? 0).toFixed(2)],
    //             ['Round Off', (header.RoundOff ?? 0).toFixed(2)],
    //             ['Total Amt', (header.GrandTotal ?? 0).toFixed(2)],
    //         ];

    //         // Tax breakdown % table
    //         const taxGroups = {};
    //         filteredItems.forEach(item => {
    //             const gst = item.GSTRate ?? 0;
    //             if (!taxGroups[gst]) {
    //                 taxGroups[gst] = { amount: 0, cgst: 0, sgst: 0 };
    //             }
    //             taxGroups[gst].amount += item.TaxableAmount ?? 0;
    //             taxGroups[gst].cgst += item.CGSTAmount ?? 0;
    //             taxGroups[gst].sgst += item.SGSTAmount ?? 0;
    //         });

    //         const taxBreakdownRows = Object.entries(taxGroups).map(([percent, vals]) => ([
    //             percent,
    //             vals.amount.toFixed(2),
    //             vals.cgst.toFixed(2),
    //             vals.sgst.toFixed(2)
    //         ]));

    //         const totalRow = taxBreakdownRows.reduce((acc, row) => {
    //             for (let i = 1; i <= 3; i++) acc[i] += parseFloat(row[i]);
    //             return acc;
    //         }, ['Total', 0, 0, 0]).map((v, i) => i === 0 ? v : v.toFixed(2));

    //         taxBreakdownRows.push(totalRow);

    //         // Tax breakdown table with borders
    //         const leftX = 5;
    //         const rightX = 75;
    //         const rowHeight = 5;
    //         const colWidths = [8, 13, 13, 13];
    //         const colTitles = ['%', 'Amount', 'CGST', 'SGST'];

    //         doc.setFontSize(6.5);
    //         doc.setFont('helvetica', 'bold');
    //         doc.text('Tax Breakdown', leftX, finalY);

    //         let tableStartY = finalY + 4;
    //         let colX = leftX;

    //         colTitles.forEach((title, i) => {
    //             doc.rect(colX, tableStartY, colWidths[i], rowHeight);
    //             doc.text(title, colX + colWidths[i] / 2, tableStartY + 3.2, { align: 'center' });
    //             colX += colWidths[i];
    //         });

    //         doc.setFont('helvetica', 'normal');
    //         let currentY = tableStartY + rowHeight;

    //         taxBreakdownRows.forEach(row => {
    //             let rowX = leftX;
    //             row.forEach((cell, i) => {
    //                 doc.rect(rowX, currentY, colWidths[i], rowHeight);
    //                 doc.text(cell.toString(), rowX + colWidths[i] / 2, currentY + 3.2, { align: 'center' });
    //                 rowX += colWidths[i];
    //             });
    //             currentY += rowHeight;
    //         });

    //         let taxBreakdownBottomY = currentY;

    //         // // Right side: Tax Summary
    //         let summaryY = finalY;
    //         doc.setFont('helvetica', 'bold');
    //         taxSummaryLines.forEach(([label, value]) => {
    //             doc.text(`${label}: ${value}`, rightX, summaryY, { align: 'right' });
    //             summaryY += 4;
    //         });

    //         finalY = Math.max(taxBreakdownBottomY, summaryY) + 2;

    //         // // Net Total
    //         // doc.setFontSize(7.5);
    //         // doc.text(`INR ${(header.GrandTotal ?? 0).toFixed(2)}`, rightX, finalY, { align: 'right' });
    //         // // Total Discount
    //         // doc.setFontSize(7.5);
    //         // doc.text(`INR ${(header.DiscountAmount ?? 0).toFixed(2)}`, rightX, finalY, { align: 'right' });
    //         // Net Total
    //         doc.setFontSize(7.5);
    //         doc.setFont('helvetica', 'bold');
    //         doc.text(`INR: ${(header.GrandTotal ?? 0).toFixed(2)}`, rightX, finalY, { align: 'right' });

    //         // Discount
    //         finalY += 4; // move 4mm down (adjust spacing as needed)
    //         doc.setFontSize(7.5);
    //         doc.setFont('helvetica', 'normal');
    //         doc.text(`Discount: ${(header.DiscountAmount ?? 0).toFixed(2)}`, rightX, finalY, { align: 'right' });


    //         // Policies
    //         const marginX = 5;
    //         const textWidth = 70;
    //         currentY = finalY + 4;

    //         doc.setFontSize(5);
    //         doc.setFont("helvetica", "bold");

    //         const policy1 = "Exchange Policy for undergarments: For hygiene reason undergarments will not be exchanged or returned.";
    //         const policy2 = "Exchange Policy for Other items: Exchange is only applicable within 7 days from the billing date. Only items with intact original tags and a valid bill will be considered for exchange.";
    //         const policy3 = "Exchange Policy for Items: Exchange is only applicable only at respective stores.";

    //         const lines1 = doc.splitTextToSize(policy1, textWidth);
    //         doc.text(lines1, marginX, currentY);
    //         currentY += lines1.length * 2;

    //         const lines2 = doc.splitTextToSize(policy2, textWidth);
    //         doc.text(lines2, marginX, currentY);
    //         currentY += lines2.length * 2;

    //         const lines3 = doc.splitTextToSize(policy3, textWidth);
    //         doc.text(lines3, marginX, currentY);
    //         currentY += lines3.length * 2;

    //         finalY = currentY + 2; // SMALL gap before footer

    //         // Footer
    //         const centerX = pageWidth / 2;
    //         // doc.setFontSize(6);
    //         // doc.text('CUSTOMER CARE: 0484 4712 91 / 9995152525', centerX, finalY, { align: 'center' });
    //         // const addressLines = doc.splitTextToSize(header.AddressLine || '', 70); // 70 is max width in mm
    //         // addressLines.forEach((line, index) => {
    //         //     doc.text(line, centerX, finalY + 3 + index * 3, { align: 'center' }); // 4 is line height
    //         // });

    //         // make sure it's normal, not bold
    //         doc.setFont('helvetica', 'bold');
    //         doc.setFontSize(6);

    //         doc.text('CUSTOMER CARE: 9995152525', centerX, finalY, { align: 'center' });

    //         const addressLines = doc.splitTextToSize(header.AddressLine || '', 70);
    //         addressLines.forEach((line, index) => {
    //             doc.text(line, centerX, finalY + 3 + index * 3, { align: 'center' });
    //         });

    //         doc.text(`GSTIN: ${header.CompanyGSTNumber || ''} `, centerX, finalY + 9, { align: 'center' });

    //         finalY += 12;
    //         doc.text(`Sales Person: ${header.SalesPersonName || ''}`, 5, finalY);
    //         doc.text(`User Name: ${header.UserName || ''}`, 5, finalY + 4);

    //         finalY += 8;
    //         doc.setFont('helvetica', 'bold');
    //         doc.setFontSize(6.5);
    //         doc.text('THANK YOU - VISIT AGAIN', 40, finalY + 4, { align: 'center' });

    //         // Save PDF
    //         //doc.save(`invoice_${invNo || saleId}.pdf`);

    //         // Generate PDF as blob and open in new tab for printing
    //         const blob = doc.output('blob');
    //         const blobUrl = URL.createObjectURL(blob);
    //         const printWindow = window.open(blobUrl, '_blank');

    //         // Auto-trigger the print dialog once the PDF is loaded
    //         if (printWindow) {
    //             printWindow.onload = function () {
    //                 printWindow.focus();
    //                 printWindow.print();
    //             };
    //         }

    //     } catch (err) {
    //         console.error("Error generating invoice:", err);
    //     }
    // };

    const generateInvoice = async (saleId) => {
        try {
            const response = await fetchData('SaleApi', `/SalePrint/${saleId}/${branchId}`, token);
            const labelData = response.response_data;

            if (!labelData?.SalePrint || !labelData?.SalePrintDetails) {
                throw new Error("Invalid invoice data.");
            }

            const header = labelData.SalePrint;
            const items = labelData.SalePrintDetails;

            const doc = new jsPDF({
                orientation: 'portrait',
                unit: 'mm',
                format: [80, 297]
            });

            let y = 6;

            doc.addImage(gender, 'PNG', 15, 2, 50, 20);
            y += 13;

            // Invoice Meta
            doc.setFontSize(6.5);
            const pageWidth = doc.internal.pageSize.getWidth();

            doc.setFont('helvetica', 'bold');
            doc.text('INVOICE', pageWidth / 2, y + 5, { align: 'center' });

            doc.setFont('helvetica', 'bold');
            const invNo = [header.BillPrefix, header.FinYear, header.BillNumber].filter(Boolean).join('/');
            doc.text(`Inv.No: ${invNo}`, 5, y + 8);
            doc.text(`Customer: ${header.CustomerName || ''}`, 5, y + 12);

            const billDate = header.BillDate || '';
            const createdDate = header.CreatedDate || '';
            //const formattedDate = billDate ? new Date(billDate).toLocaleDateString() : '';
            const formattedDate = billDate
                ? new Date(billDate).toLocaleDateString('en-GB', {
                    day: '2-digit',
                    month: 'short',
                    year: 'numeric'
                }).replace(/ /g, '-')
                : '';

            const formattedTime = createdDate ? new Date(createdDate).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : '';

            doc.text(`Date: ${formattedDate}`, pageWidth - 5, y + 8, { align: 'right' });
            doc.text(`Time: ${formattedTime}`, pageWidth - 5, y + 12, { align: 'right' });

            y += 18;

            // Filter items
            const filteredItems = items.filter(item => (item.Quantity ?? 0) > 0 || (item.Total ?? 0) > 0);

            const itemRows = filteredItems.map(item => [
                { content: item.ItemName || '', styles: { cellWidth: 30, valign: 'top' } },
                { content: (item.Quantity ?? 0).toString(), styles: { halign: 'center' } },
                { content: (item.MRP ?? 0).toFixed(2), styles: { halign: 'right' } },
                { content: (item.Rate ?? 0).toFixed(2), styles: { halign: 'right' } },
                { content: (item.TotalAmount ?? 0).toFixed(2), styles: { halign: 'right' } }
            ]);

            const totalQuantity = filteredItems.reduce((sum, item) => sum + (item.Quantity ?? 0), 0);

            itemRows.push([
                { content: 'Total', styles: { halign: 'right', fontStyle: 'bold' } },
                { content: totalQuantity.toString(), styles: { halign: 'center', fontStyle: 'bold' } },
                { content: '', styles: {} },
                { content: '', styles: {} },
                { content: (header.GrandTotal ?? 0).toFixed(2), styles: { halign: 'right', fontStyle: 'bold' } }
            ]);

            autoTable(doc, {
                startY: y,
                margin: { left: 5 },
                head: [['NAME OF PRODUCT', 'QTY', 'MRP', 'RATE', 'TOTAL']],
                body: itemRows,
                styles: {
                    fontSize: 6.5,
                    textColor: [0, 0, 0],
                    cellPadding: { top: 0.5, bottom: 0.5, left: 1, right: 1 },
                    overflow: 'linebreak',
                    lineColor: [0, 0, 0], // ⬅️ border color black
                },
                theme: 'grid',
                headStyles: {
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontStyle: 'bold',
                    lineColor: [0, 0, 0] // ⬅️ border color black for header
                },
                columnStyles: {
                    0: { cellWidth: 22 },
                    1: { cellWidth: 8 },
                    2: { cellWidth: 10 },
                    3: { cellWidth: 10 },
                    4: { cellWidth: 12 },
                },
            });


            let finalY = (doc.lastAutoTable?.finalY ?? y) + 3;

            // Tax summary
            const taxSummaryLines = [
                ['Taxable Amt', (header.TaxableAmount ?? 0).toFixed(2)],
                ['CGST Amt', (header.CGSTAmount ?? 0).toFixed(2)],
                ['SGST Amt', (header.SGSTAmount ?? 0).toFixed(2)],
                ['Round Off', (header.RoundOff ?? 0).toFixed(2)],
                ['Total Amt', (header.GrandTotal ?? 0).toFixed(2)],
            ];

            // Tax breakdown % table
            const taxGroups = {};
            filteredItems.forEach(item => {
                const gst = item.GSTRate ?? 0;
                if (!taxGroups[gst]) {
                    taxGroups[gst] = { amount: 0, cgst: 0, sgst: 0 };
                }
                taxGroups[gst].amount += item.TaxableAmount ?? 0;
                taxGroups[gst].cgst += item.CGSTAmount ?? 0;
                taxGroups[gst].sgst += item.SGSTAmount ?? 0;
            });

            const taxBreakdownRows = Object.entries(taxGroups).map(([percent, vals]) => ([
                percent,
                vals.amount.toFixed(2),
                vals.cgst.toFixed(2),
                vals.sgst.toFixed(2)
            ]));

            const totalRow = taxBreakdownRows.reduce((acc, row) => {
                for (let i = 1; i <= 3; i++) acc[i] += parseFloat(row[i]);
                return acc;
            }, ['Total', 0, 0, 0]).map((v, i) => i === 0 ? v : v.toFixed(2));

            taxBreakdownRows.push(totalRow);

            // Tax breakdown table with borders
            const leftX = 5;
            const rightX = 75;
            const rowHeight = 5;
            const colWidths = [8, 13, 13, 13];
            const colTitles = ['%', 'Amount', 'CGST', 'SGST'];

            doc.setFontSize(6.5);
            doc.setFont('helvetica', 'bold');
            doc.text('Tax Breakdown', leftX, finalY);

            let tableStartY = finalY + 4;
            let colX = leftX;

            colTitles.forEach((title, i) => {
                doc.rect(colX, tableStartY, colWidths[i], rowHeight);
                doc.text(title, colX + colWidths[i] / 2, tableStartY + 3.2, { align: 'center' });
                colX += colWidths[i];
            });

            doc.setFont('helvetica', 'normal');
            let currentY = tableStartY + rowHeight;

            taxBreakdownRows.forEach(row => {
                let rowX = leftX;
                row.forEach((cell, i) => {
                    doc.rect(rowX, currentY, colWidths[i], rowHeight);
                    doc.text(cell.toString(), rowX + colWidths[i] / 2, currentY + 3.2, { align: 'center' });
                    rowX += colWidths[i];
                });
                currentY += rowHeight;
            });

            let taxBreakdownBottomY = currentY;

            // // Right side: Tax Summary
            let summaryY = finalY;
            doc.setFont('helvetica', 'bold');
            taxSummaryLines.forEach(([label, value]) => {
                doc.text(`${label}: ${value}`, rightX, summaryY, { align: 'right' });
                summaryY += 4;
            });

            finalY = Math.max(taxBreakdownBottomY, summaryY) + 2;

            // // Net Total
            // doc.setFontSize(7.5);
            // doc.text(`INR ${(header.GrandTotal ?? 0).toFixed(2)}`, rightX, finalY, { align: 'right' });
            // // Total Discount
            // doc.setFontSize(7.5);
            // doc.text(`INR ${(header.DiscountAmount ?? 0).toFixed(2)}`, rightX, finalY, { align: 'right' });
            // Net Total
            doc.setFontSize(7.5);
            doc.setFont('helvetica', 'bold');
            doc.text(`INR: ${(header.GrandTotal ?? 0).toFixed(2)}`, rightX, finalY, { align: 'right' });

            // Discount
            finalY += 4; // move 4mm down (adjust spacing as needed)
            doc.setFontSize(7.5);
            doc.setFont('helvetica', 'normal');
            doc.text(`Discount: ${(header.DiscountAmount ?? 0).toFixed(2)}`, rightX, finalY, { align: 'right' });


            // Policies
            const marginX = 5;
            const textWidth = 70;
            currentY = finalY + 4;

            doc.setFontSize(5);
            doc.setFont("helvetica", "bold");

            const policy1 = "Exchange Policy for undergarments: For hygiene reason undergarments will not be exchanged or returned.";
            const policy2 = "Exchange Policy for Other items: Exchange is only applicable within 7 days from the billing date. Only items with intact original tags and a valid bill will be considered for exchange.";
            const policy3 = "Exchange Policy for Items: Exchange is only applicable only at respective stores.";

            const lines1 = doc.splitTextToSize(policy1, textWidth);
            doc.text(lines1, marginX, currentY);
            currentY += lines1.length * 2;

            const lines2 = doc.splitTextToSize(policy2, textWidth);
            doc.text(lines2, marginX, currentY);
            currentY += lines2.length * 2;

            const lines3 = doc.splitTextToSize(policy3, textWidth);
            doc.text(lines3, marginX, currentY);
            currentY += lines3.length * 2;

            finalY = currentY + 2; // SMALL gap before footer

            // Footer
            const centerX = pageWidth / 2;
            // doc.setFontSize(6);
            // doc.text('CUSTOMER CARE: 0484 4712 91 / 9995152525', centerX, finalY, { align: 'center' });
            // const addressLines = doc.splitTextToSize(header.AddressLine || '', 70); // 70 is max width in mm
            // addressLines.forEach((line, index) => {
            //     doc.text(line, centerX, finalY + 3 + index * 3, { align: 'center' }); // 4 is line height
            // });

            // make sure it's normal, not bold
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(6);

            doc.text('CUSTOMER CARE: 9995152525', centerX, finalY, { align: 'center' });

            const addressLines = doc.splitTextToSize(header.AddressLine || '', 70);
            addressLines.forEach((line, index) => {
                doc.text(line, centerX, finalY + 3 + index * 3, { align: 'center' });
            });

            doc.text(`GSTIN: ${header.CompanyGSTNumber || ''} `, centerX, finalY + 9, { align: 'center' });

            finalY += 12;
            doc.text(`Sales Person: ${header.SalesPersonName || ''}`, 5, finalY);
            doc.text(`User Name: ${header.UserName || ''}`, 5, finalY + 4);

            finalY += 8;
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(6.5);
            doc.text('THANK YOU - VISIT AGAIN', 40, finalY + 4, { align: 'center' });

            // Save PDF
            //doc.save(`invoice_${invNo || saleId}.pdf`);

            // Generate PDF as blob and open in new tab for printing
            const blob = doc.output('blob');
            const blobUrl = URL.createObjectURL(blob);
            const printWindow = window.open(blobUrl, '_blank');

            // Auto-trigger the print dialog once the PDF is loaded
            if (printWindow) {
                printWindow.onload = function () {
                    printWindow.focus();
                    printWindow.print();
                };
            }

        } catch (err) {
            console.error("Error generating invoice:", err);
        }
    };

    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-2 mx-auto" style={{ maxWidth: '100%' }}>

                <style>
                    {`
                        /* Hide scrollbar for Chrome, Safari, and Opera */
                        .container::-webkit-scrollbar {
                        width: 0.2em;
                        }

                        .container::-webkit-scrollbar-track {
                        background: rgba(255,255,255,0);
                        }

                        .container::-webkit-scrollbar-thumb {
                        background-color: rgba(255,255,255,0);
                        border-radius: 4px;
                        }
                    `}
                </style>

                <div className="w-full mb-2 flex">
                    <h6 className="block uppercase tracking-wide text-black productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}> Sale - Details</h6>
                    <Button
                        style={{ marginLeft: '8px', color: 'darkgreen', fontWeight: 'bolder' }}
                        onClick={() => generateInvoice(id)}
                        disabled={isLoading}
                    >
                        <PrintIcon style={{ color: 'darkgreen', fontWeight: 'bolder' }} /> Print
                    </Button>

                    <Button
                        component={Link}
                        to={`/NewSaleEdit/${id}`}
                        style={{ marginLeft: '8px', color: 'darkblue', fontWeight: 'bolder' }}
                        disabled={isLoading}
                    >
                        <EditIcon style={{ color: 'darkblue', fontWeight: 'bolder' }} /> Edit
                    </Button>

                    <Button
                        component={Link}
                        to="/NewSaleIndex"
                        className="linkcolor"
                        style={{ marginLeft: '8px', color: 'darkred', fontWeight: 'bolder' }}
                    >
                        <ArrowCircleLeftIcon style={{ color: 'darkred', fontWeight: 'bolder' }} /> Back To List
                    </Button>

                </div>

                <div className="watermark">
                    <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
                </div>

                {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                {successMessage && <p className="text-green-500">{successMessage}</p>}

                <div className="w-full mb-4 flex" style={{ marginTop: '-1.25%' }}>
                    <div className="container mx-auto mt-2 p-4 max-w-screen-md bg-tabcolor rounded-lg shadow-lg p-6" style={{ backgroundColor: 'rgba(255, 255, 255, 0.5)', maxHeight: '590px', overflowY: 'auto', maxWidth: '100%' }}>

                        <div className="w-full mb-2 flex" style={{ marginTop: '-1%' }}>

                            {roleName !== "SuperAdmin" ? (
                                <div className="w-3/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                        Customer Name
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={formData.CustomerName}
                                        type="text"
                                        placeholder="CUSTOMER NAME"
                                        name='CustomerName'
                                        readOnly
                                    />
                                </div>
                            ) : (

                                <div className="w-3/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                        Customer Name
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={formData.CustomerName}
                                        type="text"
                                        placeholder="CUSTOMER NAME"
                                        name='CustomerName'
                                        readOnly
                                    />
                                </div>
                            )}

                            {roleName !== "SuperAdmin" ? (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                        Bill Date
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={formatDateForInput(formData.BillDate)}
                                        type="date"
                                        name='BillDate'
                                        disabled
                                    />
                                </div>

                            ) : (

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                        Bill Date
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={formatDateForInput(formData.BillDate)}
                                        type="date"
                                        name='BillDate'
                                        disabled
                                    />
                                </div>
                            )}

                            {roleName !== "SuperAdmin" ? (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                        Bill Number
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={formData.BillNumber}
                                        type="text"
                                        placeholder="BILL NUMBER"
                                        name='BillNumber'
                                        readOnly
                                    />
                                </div>
                            ) : (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                        Bill Number
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={formData.BillNumber}
                                        type="text"
                                        placeholder="BILL NUMBER"
                                        name='BillNumber'
                                        readOnly
                                    />
                                </div>
                            )}

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                    Total Qty
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.TotalQuantity}
                                    type="text"
                                    placeholder="TOTAL QUANTITY"
                                    name='TotalQuantity'
                                    readOnly
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                    ADDT'L. DISC TYPE
                                    <span className="text-red-500">*</span>
                                </label>
                                <select
                                    className={`custom-select ${selectedDiscType ? 'fade-in' : 'fade-in'}`}
                                    style={{ height: '30px', fontSize: '12px' }} // Direct height control
                                    value={selectedDiscType}
                                    onChange={(e) => {
                                        const selectedValue = e.target.value;
                                        setSelectedDiscType(selectedValue);
                                        setFormData((prevFormData) => ({
                                            ...prevFormData,
                                            DiscTypeId: selectedValue,
                                        }));
                                    }}
                                    disabled
                                >
                                    <option value="">Disc Type</option>
                                    {dropdownDiscTypeOptions.map((category) => (
                                        <option key={category.Id} value={category.Id}>
                                            {category.Name}
                                        </option>
                                    ))}
                                </select>

                            </div>

                            {roleName !== "SuperAdmin" ? (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                        ADDT'L. DISC %
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={formData.AdditionalDiscountPercentage}
                                        type="number"
                                        placeholder="Disc %"
                                        style={{ textAlign: 'right' }}
                                        name='AdditionalDiscountPercentage'
                                        readOnly
                                    />
                                </div>
                            ) : (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                        ADDT'L. DISC %
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={formData.AdditionalDiscountPercentage}
                                        type="number"
                                        placeholder="Disc %"
                                        style={{ textAlign: 'right' }}
                                        name='AdditionalDiscountPercentage'
                                        readOnly
                                    />
                                </div>
                            )}

                        </div>

                        <div className="w-full mb-4 flex">
                            <div className="w-3/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                    Address
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.CustomerAddress}
                                    type="text"
                                    placeholder="Address"
                                    name='CustomerAddress'
                                    readOnly
                                />
                            </div>

                            <div className="w-2/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                    GST Number
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.GSTNumber}
                                    type="text"
                                    placeholder="GST Number"
                                    name='GSTNumber'
                                    readOnly
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                    Phone No
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.ContactNumber}

                                    type="text"
                                    placeholder="PHONE NUMBER"
                                    name='ContactNumber'
                                    readOnly
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                    Sales Man
                                    <span className="text-red-500">*</span>
                                </label>
                                <select
                                    className={`custom-select ${selectedSalesMan ? 'fade-in' : 'fade-in'}`}
                                    style={{ height: '30px', fontSize: '12px' }} // Direct height control
                                    value={selectedSalesMan}
                                    // onChange={(e) => setSelectedSalesMan(e.target.value)}
                                    onChange={(e) => {
                                        const selectedValue = e.target.value;
                                        setSelectedSalesMan(selectedValue);
                                        setFormData((prevFormData) => ({
                                            ...prevFormData,
                                            SalesManId: selectedValue,
                                        }));
                                    }}
                                    disabled
                                >
                                    <option value="">Select Sales Man</option>
                                    {dropdownSalesManOptions.map((category) => (
                                        <option key={category.Id} value={category.Id}>
                                            {category.Name}
                                        </option>
                                    ))}
                                </select>

                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="yes-no-select" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                    GWP/PWP
                                    <span className="text-red-500">*</span>
                                </label>
                                <select
                                    id="yes-no-select"
                                    className={`custom-select ${selectedGWPorPWP ? 'fade-in' : 'fade-in'}`}
                                    style={{ height: '30px', fontSize: '12px' }} // Direct height control
                                    value={selectedGWPorPWP}
                                    onChange={(e) => {
                                        const selectedValue = e.target.value === "true"; // Convert string "true"/"false" to boolean
                                        setSelectedGWPorPWP(selectedValue); // Update state with the selected value
                                        setFormData((prevFormData) => ({
                                            ...prevFormData,
                                            GWPorPWPIncluded: selectedValue, // Update form data with the selected value
                                        }));
                                    }}
                                    disabled
                                >
                                    <option value={true}>YES</option>
                                    <option value={false}>NO</option>
                                </select>
                            </div>
                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                    Total
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.GrandTotal ? formData.GrandTotal.toFixed(2) : "0.00"}
                                    type="text"
                                    placeholder="GRAND TOTAL"
                                    name='GrandTotal'
                                    readOnly
                                    style={{ textAlign: 'right', fontWeight: 'bold', color: 'darkgreen' }}
                                />
                            </div>

                        </div>
                        <div>
                            {/* Radio buttons */}
                            <div
                                className="flex justify-end items-end ml-auto"
                                style={{ marginTop: "-20px" }}
                            >
                                <label
                                    className="block uppercase tracking-wide text-gray-700 font-bold mr-0"
                                    style={{ marginLeft: "12px" }}
                                >
                                    <input
                                        type="radio"
                                        name="Paymode"
                                        value="1"
                                        checked={formData.Paymode === 1}
                                    />
                                    <span style={{ color: "blue", fontSize: "12px" }}>Digital</span>
                                </label>
                                <label
                                    className="block uppercase tracking-wide text-gray-700 font-bold mr-0"
                                    style={{ marginLeft: "12px" }}
                                >
                                    <input
                                        type="radio"
                                        name="Paymode"
                                        value="2"
                                        checked={formData.Paymode === 0}
                                    />
                                    <span style={{ color: "brown", fontSize: "12px" }}>Cash</span>
                                </label>
                            </div>
                        </div>
                        <div className="w-full mb-2 flex" style={{ marginTop: '-0.25%' }}>
                            <div className="w-full mb-2 flex">
                                <TableContainer component={Paper} style={{ maxHeight: 250 }}>
                                    <Table stickyHeader>
                                        <thead>
                                            <tr style={{ backgroundColor: '#A1D6B2' }}>
                                                <th style={{ padding: '2px', backgroundColor: '#27445D', textTransform: 'uppercase', fontSize: '13px', color: 'white', fontFamily: 'monospace' }}>Item Name</th>
                                                <th style={{ padding: '2px', backgroundColor: '#27445D', textTransform: 'uppercase', fontSize: '13px', textAlign: 'right', color: 'white', fontFamily: 'monospace' }}>Quantity</th>
                                                <th style={{ padding: '2px', backgroundColor: '#27445D', textTransform: 'uppercase', fontSize: '13px', textAlign: 'right', color: 'white', fontFamily: 'monospace' }}>Sale Price</th>
                                                <th style={{ padding: '2px', backgroundColor: '#27445D', textTransform: 'uppercase', fontSize: '13px', textAlign: 'right', color: 'white', fontFamily: 'monospace' }}>Disc %</th>
                                                <th style={{ padding: '2px', backgroundColor: '#27445D', textTransform: 'uppercase', fontSize: '13px', textAlign: 'right', color: 'white', fontFamily: 'monospace' }}> Addt'l Disc % </th>
                                                <th style={{ padding: '2px', backgroundColor: '#27445D', textTransform: 'uppercase', fontSize: '13px', textAlign: 'right', color: 'white', fontFamily: 'monospace' }}>Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {invoicedeatils.map((invdetail, index) => (
                                                <tr key={index} className={invdetail.ColorCode === '#ffffff' ? 'white-row' : ''} style={{ width: '100%' }}>
                                                    <td style={{ padding: '2px', borderBottom: '1px solid black', borderRight: '1px solid grey', fontSize: '12px', width: '45%', fontWeight: 'bold' }}>{invdetail.ItemName}</td>
                                                    <td style={{ padding: '2px', borderBottom: '1px solid black', borderRight: '1px solid grey', fontSize: '12px', width: '10%', fontWeight: 'bold', textAlign: 'right' }}>{invdetail.Quantity}</td>
                                                    <td style={{ padding: '2px', borderBottom: '1px solid black', borderRight: '1px solid grey', fontSize: '12px', width: '10%', fontWeight: 'bold', textAlign: 'right' }}>{invdetail.Rate ? invdetail.Rate.toFixed(2) : "0.00"}</td>
                                                    <td style={{ padding: '2px', borderBottom: '1px solid black', borderRight: '1px solid grey', fontSize: '12px', width: '10%', fontWeight: 'bold', textAlign: 'right' }}>{invdetail.Rate ? invdetail.DiscountPercentage.toFixed(2) : "0.00"}</td>
                                                    <td style={{ padding: '2px', borderBottom: '1px solid black', borderRight: '1px solid grey', fontSize: '12px', width: '10%', fontWeight: 'bold', textAlign: 'right' }}>{invdetail.Rate ? invdetail.AdditionalDiscountPercentage.toFixed(2) : "0.00"}</td>
                                                    <td style={{ padding: '2px', borderBottom: '1px solid black', borderRight: '1px solid grey', fontSize: '12px', width: '15%', fontWeight: 'bold', textAlign: 'right' }}>{invdetail.TotalAmount ? invdetail.TotalAmount.toFixed(2) : "0.00"}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                        {/* Footer Section */}
                                        <tfoot>
                                            <tr style={{
                                                backgroundColor: '#27445D',
                                                position: 'sticky',
                                                bottom: 0,
                                                boxShadow: '0px -2px 5px rgba(0, 0, 0, 0.1)',
                                                zIndex: 2   // important so it stays above rows
                                            }}>
                                                <td style={{ padding: '2px', fontWeight: 'bold', textAlign: 'right', fontSize: "13px", backgroundColor: '#D3DAD9' }} colSpan={1}></td>
                                                <td style={{ padding: '2px', fontWeight: 'bold', textAlign: 'right', fontSize: "13px", backgroundColor: '#D3DAD9', color: 'black' }}>
                                                    <input
                                                        type="number"
                                                        value={invoicedeatils.reduce((sum, item) => sum + Number(item.Quantity || 0), 0)}
                                                        style={{ width: "100%", fontSize: "13px", fontWeight: 'bold', padding: "4px", textAlign: 'right', backgroundColor: '#D3DAD9', color: 'black', border: 'none' }}
                                                        readOnly
                                                    />
                                                </td>
                                                <td colSpan={3} style={{ padding: '2px', backgroundColor: '#D3DAD9' }}></td>
                                                <td style={{ padding: '2px', fontWeight: 'bold', textAlign: 'right', fontSize: "13px", backgroundColor: '#D3DAD9', color: 'black' }}>
                                                    {invoicedeatils.reduce((sum, item) => sum + Number(item.TotalAmount || 0), 0).toFixed(2)}
                                                </td>
                                                <td style={{ backgroundColor: '#D3DAD9' }}></td>
                                            </tr>
                                        </tfoot>

                                    </Table>
                                </TableContainer>
                            </div>
                        </div>

                        <div className="w-full mb-2 flex" style={{ marginTop: '-0.90%' }}>
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                Remarks
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                value={formData.Remarks}
                                type="text"
                                placeholder="REMARKS"
                                name='Remarks'
                                readOnly
                            />
                        </div>
                    </div>

                </div>


            </div >
        </Fragment >

    );
};

export default NewSaleDetails;